import { useEventCallback } from '@cian/react-utils';
import { useDeviceType, TDeviceType } from '@cian/ui-kit';
import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { DeviceTypeContext } from '../../context';
import { useAppDispatch } from 'shared/hooks';
import { resetOffers } from 'shared/slices/offers';

/**
 * Кастомный провайдер useDeviceType на основе ширины экрана
 */
export const DeviceTypeProvider: FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();

  const deviceType = useDeviceType();

  const [currentDeviceType, setCurrentDeviceType] = useState<TDeviceType>(
    deviceType === 'phone' ? 'tablet' : 'desktop',
  );

  const updateDeviceAfterResize = useEventCallback(() => {
    const device = window.matchMedia('(max-width: 1024px)').matches ? 'tablet' : 'desktop';

    setCurrentDeviceType(prevDevice => {
      /** При ресайзе обязательно нужно сбрасывать офферы, иначе они отрендерятся не в том виджете и страница упадет */
      if (prevDevice !== device) {
        dispatch(resetOffers());
      }

      return device;
    });
  });

  useEffect(() => {
    updateDeviceAfterResize();

    window.addEventListener('resize', updateDeviceAfterResize);

    return () => window.removeEventListener('resize', updateDeviceAfterResize);
  }, [updateDeviceAfterResize]);

  return <DeviceTypeContext.Provider value={currentDeviceType}>{children}</DeviceTypeContext.Provider>;
};
